import { render, staticRenderFns } from "./DayworksBreakdownItem.vue?vue&type=template&id=1ecc6586&"
import script from "./DayworksBreakdownItem.vue?vue&type=script&lang=js&"
export * from "./DayworksBreakdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports